import { ArrowRight } from "lucide-react";
import { CTA_CONFIG } from "@/config/cta";
import { useCta } from "./CtaProvider";

const VARIANTS = {
  primary: "bg-teal text-white hover:bg-teal-dark shadow-[0_14px_34px_-12px_rgba(12,166,162,0.6)]",
  gold: "bg-gold text-navy hover:bg-[#ecae5c] shadow-[0_14px_34px_-12px_rgba(243,190,120,0.7)]",
  navy: "bg-navy text-cream hover:bg-[#0c2644]",
};

export const CtaButton = ({ testId, source, label = CTA_CONFIG.label, variant = "primary", size = "lg", className = "" }) => {
  const { openCta } = useCta();
  const sizing = size === "sm" ? "h-11 px-5 text-sm" : "h-14 px-7 text-base";
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => openCta(source)}
      className={`group relative inline-flex items-center justify-center gap-2 rounded-full font-heading font-extrabold tracking-tight transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-teal/40 ${sizing} ${VARIANTS[variant]} ${className}`}
    >
      <span>{label}</span>
      <ArrowRight aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </button>
  );
};
